<div class="data-grid-search">
  <input nz-input [placeholder]="placeholderSearch" aria-label="Buscar en la tabla" (ngModelChange)="filtrarTabla($event)" [ngModel]="terminoBusqueda" class="grid-search" />
</div>
<div class="data-grid-actions">
  <button type="button" nz-button nzSize="small" (click)="primeraPagina()"><i class="fas fa-angle-double-left"></i></button>
  <button type="button" nz-button nzSize="small" (click)="paginaAnterior()"><i class="fas fa-angle-left"></i></button>
  <button type="button" nz-button nzSize="small" (click)="paginaSiguiente()"><i class="fas fa-angle-right"></i></button>
  <button type="button" nz-button nzSize="small" (click)="ultimaPagina()"><i class="fas fa-angle-double-right"></i></button>
  <button type="button" nz-button nzSize="small" (click)="refrescarTabla()" [disabled]="loading"><i class="fa fa-sync"></i></button>
  <span class="grid-page-indicator">{{ 'pagina' | translate }} {{ currentPage }} {{ 'de' | translate }} {{ totalPages }}</span>
</div>
<nz-table #tabla [nzData]="filteredData" [nzPageIndex]="currentPage" [nzPageSize]="pageSize" [nzShowSizeChanger]="false" (nzPageIndexChange)="currentPage = $event">
  <thead>
    <tr>
      @for (column of displayedColumns; track column) {
      <th scope="col">{{ column.headerName || column.field }}</th>
      }
    </tr>
  </thead>
  <tbody>
    @for (row of tabla.data; track row) {
    <tr (dblclick)="onSelected.emit(row)">
      @for (column of displayedColumns; track column) {
      <td>{{ value(row, column) }}</td>
      }
    </tr>
    }
  </tbody>
</nz-table>
